import { useMyAvailabilityExceptionRequestsQuery } from '../gql/graphql.generated';

export const useMyAvailabilityExceptionRequests = () => {
  const [result, refetch] = useMyAvailabilityExceptionRequestsQuery({
    requestPolicy: 'network-only'
  });

  return {
    requests: result.data?.myAvailabilityExceptionRequests ?? [],
    refetch
  };
};
